import { render, staticRenderFns } from "./AtopicDermatitisInfoDialogActivator.vue?vue&type=template&id=0f092674&"
import script from "./AtopicDermatitisInfoDialogActivator.vue?vue&type=script&lang=js&"
export * from "./AtopicDermatitisInfoDialogActivator.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports